export const removeAllNodesHasEmptyChildrenProp = (arr) => {
  if (arr instanceof Array) {
    return (
      arr
        // Remove all node has children prop but children is empty []
        .map((item) => {
          if (item?.type && item?.children) {
            const newItem = { ...item };
            newItem.children = removeAllNodesHasEmptyChildrenProp([...newItem.children]);
            if (newItem.children.length === 0) {
              return null;
            }
            return newItem;
          }
          return item;
        })
        .filter(Boolean)
    );
  }
  return arr;
};
